import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type NetworkState = { inFlight: number };
const initialState: NetworkState = { inFlight: 0 };

const networkSlice = createSlice({
  name: "network",
  initialState,
  reducers: {
    bump(state, action: PayloadAction<1 | -1>) {
      state.inFlight = Math.max(0, state.inFlight + action.payload);
    },
    reset(state) {
      state.inFlight = 0;
    },
  },
});

export const { bump, reset } = networkSlice.actions;
export const networkReducer = networkSlice.reducer;
export default networkSlice.reducer;
